export const mockFrontPhoto = '/assets/images/front-side-driver-license.png'
export const mockBackPhoto = '/assets/images/back-side-driver-license.png'
